import React, { useRef } from "react";
import { Modal, Button } from "antd";
import { useReactToPrint } from "react-to-print";
import { toWords } from "number-to-words";
import logoHeader from "../../assets/header_letterhead.png";
import logoFooter from "../../assets/footer.png";

const PurchaseOrderModal = ({ visible, modalClose, data }) => {
  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Purchase_Order_${data?.po_reference}`,
    pageStyle: `
      @page {
        size: A4;
        margin: 0;
        @top-left {
          content: element(po-header);
        }
      }

      header.po-header {
        position: running(po-header);
      }

      @media print {
        body {
          -webkit-print-color-adjust: exact;
          font-family: sans-serif;
          font-size: 14px;
          margin: 0;
        }

        .printable-content {
          overflow: visible !important;
          max-height: none !important;
        }

        table {
          border-collapse: collapse;
          width: 100%;
          page-break-inside: auto;
        }
        tr {
          page-break-inside: avoid;
          page-break-after: auto;
        }
        th, td {
          border: 1px solid #000;
          padding: 4px;
          font-size: 14px;
        }

        .ant-modal-content {
          overflow: visible !important;
        }

        .no-print {
          display: none !important;
        }

        /* Fixed footer at bottom */
        .po-footer-fixed {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
        }
      }
    `,
  });

  return (
    <Modal open={visible} onCancel={modalClose} footer={false} width="40%">
      <div ref={printRef}>
        {/* Header for printing */}
        <header className="po-header" style={{ textAlign: "left" }}>
          <img src={logoHeader} alt="Header" style={{ width: "40%" }} />
        </header>

        {/* Scrollable content for on-screen modal */}
        <div
          className="printable-content"
          style={{ maxHeight: "800px", overflowY: "auto", fontSize: "14px" }}
        >
          <div className="w-full p-3 text-sm leading-relaxed font-sans">
            <h5 className="text-center font-bold text-lg mb-4">
              Purchase Order
            </h5>

            <div className="ps-5">
              <div className="mb-4">
                <p>
                  <strong>Ref: {data?.po_reference}</strong> <br />
                  <strong>
                    Date:{" "}
                    {data?.po_date
                      ? new Date(data.created_at).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      : ""}
                  </strong>
                </p>
              </div>

              <div className="mb-4">
                <p>
                  <strong>
                    To: {data?.supplier_name} <br />
                    {data?.supplier_address}
                  </strong>{" "}
                  <br />
                  Mobile: {"0" + data?.supplier_phone}
                </p>
                <p>
                  <strong>Receiving Address:</strong> {data?.center_address}
                  <br />
                </p>
              </div>

              <table className="w-full border-collapse mb-4 text-sm">
                <thead>
                  <tr className="border">
                    <th className="border p-2">Sl</th>
                    <th className="border p-2">Description Of Item</th>
                    <th className="border p-2">Size</th>
                    <th className="border p-2">Unit Price</th>
                    <th className="border p-2">Order Qty</th>
                    <th className="border p-2">Total Amount</th>
                    <th className="border p-2">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.item_details.map((item, index) => (
                    <tr key={index} className="border">
                      <td className="border p-2 text-center">{index + 1}</td>
                      <td className="border p-2">
                        {item?.product?.product_name}
                      </td>
                      <td className="border p-2 text-right">{item?.size}</td>
                      <td className="border p-2 text-right">
                        {Number(item?.unit_price).toFixed(2)}
                      </td>
                      <td className="border p-2 text-right">
                        {Number(item?.quantity).toLocaleString()}
                      </td>
                      <td className="border p-2 text-right">
                        {item?.total_price.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td className="border p-2">{item?.remarks}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="mb-4 font-bold text-right">
                Total Price:{" "}
                {Number(data?.total_amount).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </div>

              <div className="mb-4" style={{ textTransform: "capitalize" }}>
                <strong>
                  In Word: {toWords(data?.total_amount)} Taka Only
                </strong>
              </div>

              <div
                className="mb-6"
                dangerouslySetInnerHTML={{ __html: data?.terms_conditions }}
              />

              <div className="mt-5">
                <p>
                  <strong>{data?.initiated_by_name}</strong>
                </p>
                <p>{data?.initiated_by?.designation}</p>
                <p>Agrigate Network Limited</p>
              </div>
            </div>
          </div>
        </div>

        {/* Fixed Footer */}
        <div className="po-footer-fixed">
          <img src={logoFooter} alt="Footer" style={{ width: "100%" }} />
        </div>
      </div>

      {/* Print button */}
      <div className="no-print d-flex justify-content-center mt-3">
        <Button
          style={{
            backgroundColor: "#46604A",
            borderColor: "#46604A",
            color: "#fff",
          }}
          onClick={handlePrint}
          className="d-flex justify-center px-5"
        >
          Print
        </Button>
      </div>
    </Modal>
  );
};

export default PurchaseOrderModal;
